/**
 * Application Configuration
 * Centralized config for API keys and settings
 */

// Google reCAPTCHA v2 Site Key
// Get your key from: https://www.google.com/recaptcha/admin
export const RECAPTCHA_SITE_KEY = '6Lf7PEcsAAAAAJ3w6keAIRyOwdLMmkhZIZIjs4-p';

// EmailJS Configuration
export const EMAILJS_CONFIG = {
    SERVICE_ID: 'service_mo89ytr',
    PUBLIC_KEY: 'Z09uORacFkb-c0Pas',
    TEMPLATES: {
        CONTACT: 'template_t2mwt2n',
        REGISTER: 'template_4k2r9xf',
        CAREERS: 'template_careers'
    }
};
